var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbstract1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4569 2.80941C12.5509 2.30604 11.4491 2.30604 10.5431 2.80941L4.54307 6.14275C3.59068 6.67185 3 7.67572 3 8.76522V15.2348C3 15.5234 3.04144 15.806 3.12007 16.0753L7.00056 13.9195C7.00012 13.9022 6.99989 13.8849 6.99989 13.8676V10.1324C6.99989 9.42988 7.36849 8.77886 7.9709 8.41742L10.9709 6.61742C11.6043 6.2374 12.3955 6.2374 13.0289 6.61742L16.0289 8.41742C16.1633 8.49806 16.2861 8.59312 16.3957 8.69995L20.1125 6.63504C19.9202 6.44425 19.7004 6.27799 19.4569 6.14275L13.4569 2.80941Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8799 7.92462L16.9992 10.0806C16.9997 10.0978 16.9999 10.1151 16.9999 10.1324V13.8676C16.9999 14.5702 16.6313 15.2212 16.0289 15.5826L13.0289 17.3826C12.3955 17.7626 11.6043 17.7626 10.9709 17.3826L7.97087 15.5826C7.83647 15.502 7.7137 15.4069 7.60407 15.3001L3.88739 17.3649C4.07975 17.5557 4.29958 17.722 4.54304 17.8573L10.5431 21.1906C11.4491 21.694 12.5509 21.694 13.4569 21.1906L19.4569 17.8573C20.4093 17.3282 21 16.3243 21 15.2348V8.76519C21 8.47658 20.9585 8.19398 20.8799 7.92462Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract1);
export default __webpack_public_path__ + "static/media/abstract-1.3dcf999ebd384c9e90a4bf5c5a705d3a.svg";
export { ForwardRef as ReactComponent };